module.exports = __webpack_public_path__ + "img/location-icon.de910e98.svg";